import { render, staticRenderFns } from "./deleteTratamentButton.vue?vue&type=template&id=11ebbdb4&"
import script from "./deleteTratamentButton.vue?vue&type=script&lang=js&"
export * from "./deleteTratamentButton.vue?vue&type=script&lang=js&"
import style0 from "./deleteTratamentButton.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports